import CBSEResult from "../components/pages/CBSEResults";

export default CBSEResult;
